export default "__VITE_ASSET__BzsStIV___"